import * as Sentry from "@sentry/react";
import { matchPath } from "react-router-dom";
import { createBrowserHistory } from "history";
import { BrowserTracing } from "@sentry/tracing";
import Config from "../config";
import * as Package from "../../package.json";
import { ROUTES } from "../utils/constant";

const history = createBrowserHistory();

const routes = Object.values(ROUTES).map((o) => ({ path: o.URL }));

const configureSentry = () => {
  if (Config.sentryURL) {
    Sentry.init({
      dsn: Config.sentryURL,
      integrations: [
        new BrowserTracing({
          tracingOrigins: [Config.domain],
          routingInstrumentation: Sentry.reactRouterV5Instrumentation(
            history,
            routes,
            matchPath
          ),
        }),
      ],
      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      // We recommend adjusting this value in production
      tracesSampleRate: 1.0,
      debug: Config.env === "prod" ? false : true,
      release: Package.version,
    });
  }
};

export default configureSentry;
